






import { Vue, Component, Prop } from 'vue-property-decorator'
import { Skill } from '@/static/ts/skill'

@Component
export default class SkillDescript extends Vue {
  @Prop() private skill!: Skill
}
